import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function RenewDialog({
    open,
    loading,
    onClose,
    onConfirm,
}: {
    open: boolean,
    loading: boolean,
    onClose: () => void,
    // eslint-disable-next-line no-unused-vars
    onConfirm: (newEndDate: string) => void,
}) {
    const [newEndDate, setNewEndDate] = useState<string>("");

    const handleClose = () => {
        setNewEndDate("");
        onClose();
    };

    const handleConfirm = () => {
        if (newEndDate) onConfirm(newEndDate);
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Renew Contract</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="New End Date"
                    sx={{ marginTop: "1em", minWidth: "300px" }}
                    type="date"
                    value={newEndDate}
                    onChange={(e) => setNewEndDate(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={handleClose}>
                    Cancel
                </Button>
                <LoadingButton
                    disabled={!newEndDate || loading}
                    loading={loading}
                    variant="contained"
                    onClick={handleConfirm}
                >
                    Renew
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
